/* eslint-disable fp/no-mutation */
import axios, { AxiosResponse } from 'axios'

export let uploadImageToS3 = async (
  thumbnail: string,
  signedUrl: string,
): Promise<AxiosResponse> => {
  let binary = atob(thumbnail.split(',')[1])
  let array = new Array(binary.length)
    .fill('')
    .map((_, i) => binary.charCodeAt(i))
  let blobData = new Blob([new Uint8Array(array)], { type: 'image/jpeg' })

  try {
    let response = await axios.put(signedUrl, blobData, {
      headers: {
        'Cache-Control': 'max-age=2592000',
        'content-type': 'image/jpeg',
      },
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

type ProcessImageFileParams = {
  onLoadingStart?: () => void
  onLoadingEnd?: (thumbnail: string, file?: File) => void
}

export let processImageFile = (
  event: React.ChangeEvent<HTMLInputElement>,
  params: ProcessImageFileParams,
): void => {
  let { onLoadingStart, onLoadingEnd } = params

  let file = event.currentTarget.files?.[0]
  if (!file) {
    return
  }

  let reader = new FileReader()

  reader.onloadstart = () => {
    if (onLoadingStart) {
      onLoadingStart()
    }
  }

  reader.onloadend = () => {
    let thumbnail = reader.result as string
    if (onLoadingEnd) {
      onLoadingEnd(thumbnail, file)
    }
  }

  reader.readAsDataURL(file)
}
